import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const LOGO_ICON = "/logo-emblem.png";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-[#F3EDE3] border-t border-[#B38728]/30" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div className="flex items-start gap-4">
            <img src={LOGO_ICON} alt="Stud Exchange" className="w-14 h-14 rounded-full object-cover border border-[#B38728]/40" />
            <div>
              <p className="font-serif text-xl">STUD EXCHANGE</p>
              <p className="font-mono text-[10px] tracking-[0.35em] gold-text mt-1">BUY • SELL • TRADE • COLLECT</p>
              <a
                href="mailto:Officialstudexchange@hotmail.com"
                data-testid="contact-email-link"
                className="mt-4 inline-flex items-center gap-2 text-sm text-[#a79f90] hover:text-[#D4AF37] transition-colors"
              >
                <Mail className="w-4 h-4" /> Officialstudexchange@hotmail.com
              </a>
            </div>
          </div>
          <nav className="grid grid-cols-2 gap-x-16 gap-y-3">
            {[["#stock", "Stock"], ["#valuation", "Free Valuation"], ["#trade", "Sell & Trade"], ["#socials", "Socials"]].map(([href, label]) => (
              <a key={href} href={href} className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#a79f90] hover:text-[#D4AF37] transition-colors" data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]/g, "-")}`}>
                {label}
              </a>
            ))}
            <Link to="/track" className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#a79f90] hover:text-[#D4AF37] transition-colors" data-testid="footer-link-track-your-offer">
              Track Your Offer
            </Link>
            <Link to="/admin" className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#5C564C] hover:text-[#D4AF37] transition-colors" data-testid="footer-admin-link">
              Admin
            </Link>
          </nav>
        </div>
        <div className="mt-14 pt-8 border-t border-[#3a372f]">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#5C564C] mb-4">The Fine Print</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {[
              ["terms", "Terms & Conditions"],
              ["returns", "Returns & Refunds"],
              ["shipping", "Shipping & Delivery"],
              ["privacy", "Privacy Policy"],
              ["cookies", "Cookie Policy"],
              ["authenticity", "Authenticity & Condition"],
              ["selling", "Selling & Valuation Terms"],
              ["contact", "Contact / Business Details"],
            ].map(([id, label]) => (
              <Link
                key={id}
                to={`/policies#${id}`}
                data-testid={`footer-policy-${id}`}
                className="text-xs text-[#a79f90] hover:text-[#D4AF37] transition-colors"
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-[#3a372f] flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-xs text-[#5C564C]">© {new Date().getFullYear()} Stud Exchange. All rights reserved.</p>
          <p className="text-xs text-[#5C564C]">LEGO® is a trademark of the LEGO Group, which does not sponsor or endorse this site.</p>
        </div>
      </div>
    </footer>
  );
}
